<template>
    <div class="blog__head">
        <div class="blog__container container">
            <div class="blog__filter">
                Filter
                <svg width="512px" height="512px" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                    <path d="M238.627,496H192V253.828l-168-200V16H480V53.612l-160,200V414.627ZM224,464h1.373L288,401.373V242.388L443.51,48H60.9L224,242.172Z" class="ci-primary" />
                </svg>
            </div>
            <div class="filters">
                <div class="filters__head">
                    <div class="filters__title">Filter</div>
                    <button class="filters__close"><svg xmlns="http://www.w3.org/2000/svg" width="17.678" height="17.678" fill="#009dbb" viewBox="0 0 18 18"><path d="M16.97 2.122L2.121 16.971a1 1 0 1 1-1.414-1.414L15.556.708a1 1 0 1 1 1.414 1.414z" /><path d="M15.556 16.97L.707 2.121A1 1 0 1 1 2.121.707L16.97 15.556a1 1 0 1 1-1.414 1.414z" /></svg></button>
                </div>
                <div class="filters__body">
                    <div class="filters__row">
                        <div class="filters__col">
                            <ul class="filters__links">
                                <li><a :class="{ 'active' : catId == 0 }" @click="setCategory(0)">Latest</a></li>
                                <li v-for="cat in categories"><a :class="{ 'active' : catId == cat.Id }" @click="setCategory(cat.Id)">{{cat.Name}}</a></li>
                            </ul>
                        </div>
                        <div class="filters__col">
                            <div class="filters__search">
                                <button class="filters__button" @click="emitChange">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
                                        <path d="M18.582 16.352h-1.174l-.416-.4A9.68 9.68 0 0 0 2.806 2.807a9.68 9.68 0 0 0 13.145 14.186l.4.416v1.174L23.785 26 26 23.785zm-8.919 0a6.69 6.69 0 1 1 0-13.38 6.69 6.69 0 0 1 6.69 6.69 6.68 6.68 0 0 1-6.69 6.69z" fill="#f24b4d" />
                                    </svg>
                                </button>
                                <input class="filters__input" type="text" v-model="query" name="query" placeholder="Search" @keydown.enter="emitChange">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            articlePageId: Number,
            articlePageUrl: String,

        },
        data() {
            return {
                categories: [],
                catId: 0,
                query: '',
            }
        },
        methods: {
            setCategory(catId) {
                this.catId = catId
                this.emitChange()
            },
            emitChange() {
                var vm = this
                this.$emit('changed', { query: vm.query, catId: vm.catId })
            }
        },
        mounted() {
            var vm = this
            vm.doPost('/umbraco/surface/article/getcategories', { articlePageId: vm.articlePageId }, (data) => {
                vm.categories = data
            })
            if (vm.querystringObject.catid) vm.catId = parseInt(vm.querystringObject.catid)
            if (vm.querystringObject.query) vm.query = vm.querystringObject.query
            if (vm.catId > 0 || vm.query != '') this.emitChange()
        }
    }
</script>